export var inmateAccount = function inmateAccount(siteApi, centralApi) {
  return {
    activity: {
      index: function index(params) {
        return centralApi.get('/inmate-account/activity', {
          params: params
        });
      },
      post: function post(data) {
        return siteApi.post('/inmate-account/activity', data);
      }
    },
    audioVideoSummary: function audioVideoSummary(params) {
      if (params === void 0) {
        params = {};
      }
      return centralApi.get('/inmate-account/audio-video/summary', {
        params: params
      });
    },
    summary: function summary(params) {
      if (params === void 0) {
        params = {};
      }
      return centralApi.get('/inmate-account/summary', {
        params: params
      });
    },
    commissaryTransfer: {
      index: function index(params) {
        return centralApi.get('/inmate-account/commissary-transfer', {
          params: params
        });
      },
      post: function post(data) {
        return centralApi.post('/inmate-account/commissary-transfer', data);
      },
      delete: function _delete(id, description) {
        return centralApi.delete("/inmate-account/commissary-transfer/".concat(id), {
          params: {
            description: description
          }
        });
      }
    },
    loadPhoneCard: {
      post: function post(data) {
        return siteApi.post('/inmate-account/load-phone-card', data);
      }
    }
  };
};